import styled from "styled-components"
import TransitionFade from "../components/transition-fade"

const StyledLink = styled(TransitionFade)`
  color: black;
`
export { StyledLink }
